const convertFacebookTagsToHumanReadable = (text: string) => {
  return text.replaceAll(/@\[(fb_)*(.+?):\d+]/g, '@$2');
};

const removeControlCharacters = (text: string) => {
  return text.replace(/[\u0000-\u001F\u007F-\u009F\u202A\u202B\u202C\u202D\u202E\u2066\u2067\u2068\u2069]/g, '');
};

export default {
  convertFacebookTagsToHumanReadable,
  removeControlCharacters,
};
